import type { OnPageCharacteristicAttributeItemProps } from ".."

export const POSITIVE_OPC = [
  "Mentoring Exp",
  "Team Building Exp",
  "Team Lead Exp",
  "Has Publications",
  "Certified",
  "Volunteer Exp",
  "Highly Endorsed",
  "Highly Recommended",
  "Is Ambitious",
  "Has Good English",
  "Went To Top School",
  "Worked At Top Company",
] as const

export const NEGATIVE_OPC = ["Overlapping Jobs", "Has Career Gap", "Is A Job Hopper"] as const

export type PositiveOPC = (typeof POSITIVE_OPC)[number]

export type NegativeOPC = (typeof NEGATIVE_OPC)[number]

export const isTopSchoolOpc = (opca: OnPageCharacteristicAttributeItemProps) => opca.label === "Went To Top School"
